/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unsafe-storage */
'use es6'; // TODO: Only use active user - no pass back/forth.
// TODO: No need to parse/stringify API result now.

import userInfo from 'hub-http/userInfo';
import http from 'hub-http/clients/apiClient';
import Settings from 'react-codemirror/model/Settings'; // https://git.hubteam.com/HubSpot/DesignManagerApi/pull/1035

export const ATTRIBUTE_KEY = 'react-codemirror-settings';
const URI_BASE = `designmanager/v1/attributes/user/${ATTRIBUTE_KEY}`;

const createLocalStorageKey = userId => `${ATTRIBUTE_KEY}:user:${userId}`;

let lastFetchRequestId = 0;
let lastUpdateRequestId = 0;
/**
 *
 * @param {Number} userId
 * @param {String} result
 */

function parseSettings(userId, result) {
  let settings;

  try {
    if (result && typeof result === 'string') {
      settings = JSON.parse(result);
    }

    if (settings !== Object(settings)) {
      settings = null;
    }
  } catch (err) {
    settings = null;
  }

  const model = Settings.getByUserId(userId);

  if (settings) {
    Object.assign(model, settings);
  }

  return model;
}
/**
 *
 * @param {Settings} settings
 */


function stringifySettings(settings) {
  if (!settings) {
    return null;
  }

  let result;

  try {
    result = JSON.stringify(settings);
  } catch (e) {
    result = null;
  }

  return result;
}
/**
 *
 * @param {Number} userId - Optional.
 */


function fetchUserId(userId) {
  if (userId) {
    return Promise.resolve(userId);
  }

  return userInfo().then(({
    user
  }) => user.user_id);
}
/**
 * Fetches user settings from localStorage
 *
 * @param {Number} userId
 * @returns {Settings|Null}
 */


export function fetchSettingsFromLocalStorage(userId) {
  if (!userId) {
    return null;
  }

  const key = createLocalStorageKey(userId);
  const stored = localStorage.getItem(key);
  return parseSettings(userId, stored);
}
/**
 * Saves user settings to localStorage
 *
 * @param {Number} userId
 * @param {Settings} settings
 */

export function saveSettingsToLocalStorage(userId, settings, {
  onError
} = {}) {
  if (!(userId && settings)) {
    return;
  }

  const key = createLocalStorageKey(userId);

  try {
    const value = stringifySettings(settings);
    localStorage.setItem(key, value);
  } catch (error) {
    if (typeof onError === 'function') {
      onError(error);
    }
  }
}
/**
 *
 * @param {Object} data
 * @param {Number} userId
 * @param {Function} onSuccess
 */

function handleApiData(data, userId, onSuccess) {
  const model = Settings.getByUserId(userId);

  if (data && typeof data === 'object') {
    Object.assign(model, data);
  } else {
    Settings.reset(model);
  }

  saveSettingsToLocalStorage(userId, model);

  if (onSuccess) {
    onSuccess({
      userId,
      settings: model
    });
  }
}
/**
 *
 * @param {Object}    options
 * @param {Function}  options.onSuccess
 * @param {Function}  options.onError
 * @param {Number}    options.userId - If not provided the authed user will be used.
 */


export function fetchSettings({
  onSuccess,
  onError,
  userId
} = {}) {
  const requestId = ++lastFetchRequestId;
  const invokedWithUserId = !!userId;

  const handleLocalStorageFetch = uid => {
    const settings = fetchSettingsFromLocalStorage(uid);

    if (settings && onSuccess) {
      onSuccess({
        userId: uid,
        settings
      });
    }
  };

  if (invokedWithUserId) {
    handleLocalStorageFetch(userId);
  }

  return fetchUserId(userId).then(__userId => {
    if (requestId !== lastFetchRequestId) {
      return null;
    }

    userId = __userId;

    if (!invokedWithUserId) {
      handleLocalStorageFetch(userId);
    }

    return http.get(URI_BASE);
  }).then(data => {
    if (requestId !== lastFetchRequestId) {
      return null;
    }

    return handleApiData(data, userId, onSuccess);
  }).catch(error => {
    if (onError && requestId === lastFetchRequestId) {
      onError({
        userId,
        error
      });
    }
  });
}
/**
 *
 * @param {Object}    options
 * @param {Settings}  options.settings
 * @param {Function}  options.onSuccess
 * @param {Function}  options.onError
 * @param {Number}    options.userId - If not provided the authed user will be used.
 */

export function updateSettings({
  settings,
  onSuccess,
  onError,
  userId
} = {}) {
  const requestId = ++lastUpdateRequestId;
  return fetchUserId(userId).then(__userId => {
    userId = __userId;
    return http.put(URI_BASE, {
      data: settings
    });
  }).then(data => {
    if (requestId !== lastUpdateRequestId) {
      return null;
    }

    return handleApiData(data, userId, onSuccess);
  }).catch(error => {
    if (onError && requestId === lastFetchRequestId) {
      onError({
        userId,
        error
      });
    }
  });
}